export default "__VITE_ASSET__DWoIoNpW__"